import { atom, PrimitiveAtom } from 'jotai'
import type { Map, Poi, Tag } from '@/js/types'

export type MapId = string | number

export type MapData = {
    name: string | null
    zoom: number
    center: [number, number] | null
    colors: {
        primary: string | null
        standard: string | null
        highlight: string | null
        background: string | null
    }
    uses_tags_as_categories: boolean | null
    map_type: 'image' | 'geographic' | null
    show_short_description_in_sidebar: boolean | null
}

export const emptyMapData: MapData = {
    name: null,
    zoom: 1,
    center: null,
    colors: {
        primary: null,
        standard: null,
        highlight: null,
        background: null,
    },
    uses_tags_as_categories: null,
    map_type: null,
    show_short_description_in_sidebar: null,
}

type MapSession = {
    id: MapId | null
    map: Map | null
}

export const mapSessionAtom: PrimitiveAtom<MapSession> = atom<MapSession>({
    id: null,
    map: null,
})

export const mapSessionIdAtom = atom((get) => get(mapSessionAtom).id)
export const currentMapAtom = atom((get) => get(mapSessionAtom).map)

export const mapImageAtom = atom((get) => get(currentMapAtom)?.image ?? null)
export const poisAtom = atom<Poi[]>((get) => get(currentMapAtom)?.pois ?? [])
export const tagsAtom = atom<Tag[]>((get) => get(currentMapAtom)?.tags ?? [])

export const mapDataAtom = atom<MapData>((get) => {
    const map = get(currentMapAtom)

    if (!map) {
        return emptyMapData
    }

    return {
        name: map.name,
        zoom: map.zoom ?? 1,
        center: map.center ?? null,
        colors: {
            primary: map.primary_color ?? '#676d7e',
            standard: map.color ?? '#00a6ff',
            highlight: map.highlight_color ?? '#abd6ec',
            background: map.background_color ?? '#dfdfdf',
        },
        uses_tags_as_categories: map.uses_tags_as_categories ?? null,
        map_type: map.map_type ?? null,
        show_short_description_in_sidebar: map.show_short_description_in_sidebar ?? null,
    }
})
